import {MediaAxios} from "../../common/Axios";

const isInit = false;

const ACTION_URL = '/dashboard';
const REVENUE = '/revenue'
const THIS_MONTH = '/this-month'
const LAST_30TH = '/last-30th'
const REVENUE_SHARE = '/revenue-share'
const MAJOR_BY_PERIOD = '/major-by-period'
const SLASH = '/'

export async function dashboardUserRevenue(userId) {
  let returnVal = null;
  if (isInit) {
    return {
      todayAmount: 0,
      yesterdayAmount: 0,
      last7daysAmount: 0,
      thisMonthAmount: 0,
    };
  }

  if (userId !== '') {
    await MediaAxios('GET', ACTION_URL + REVENUE + SLASH + userId, null)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = false;
      }
    }).catch((e) => returnVal = false)
  }
  return returnVal;
};

export async function dashboardUserThisMonth(userId) {
  let returnVal = null;
  if (userId !== '') {
    await MediaAxios('GET', ACTION_URL + THIS_MONTH + SLASH + userId, null)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = false;
      }
    }).catch((e) => returnVal = false)
  }
  return returnVal;
};

export async function dashboardUserLastMonth(userId) {
  let returnVal = null;
  if (userId !== '') {
    await MediaAxios('GET', ACTION_URL + LAST_30TH + SLASH + userId, null)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = false;
      }
    }).catch((e) => returnVal = false)
  }
  return returnVal;
}

export async function dashboardUserRevenueShare(TYPE, userId, condition = {}) {
  let returnVal = null;
  if (userId !== '') {
    const query = new URLSearchParams({
      searchStartDate: condition.startDate || '',
      searchEndDate: condition.endDate || '',
    }).toString()
    await MediaAxios('GET',
        ACTION_URL + REVENUE_SHARE + SLASH + TYPE + SLASH + userId
        + (query ? `?${query}` : ''), null)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = false;
      }
    }).catch((e) => returnVal = false)
  }
  return returnVal;
}

export async function dashboardUserPeriodStatus(TYPE, userId) {
  let returnVal = null;
  if (userId !== '') {
    await MediaAxios('GET',
        ACTION_URL + MAJOR_BY_PERIOD + SLASH + TYPE + SLASH + userId, null)
    .then((response) => {
      const { data, statusCode } = response;
      if(statusCode === 200){
        returnVal = data;
      }else{
        returnVal = false;
      }
    }).catch((e) => returnVal = false)
  }
  return returnVal;
}
